import getInsertLinkViewState from '../selectors/getInsertLinkViewState';

export function isInsertLinkPendingOrFailed(linkId: string): boolean {
    const viewState = getInsertLinkViewState(linkId);
    return !!viewState;
}
